import React from "react";
import { Provider } from "react-redux";
import { createRoot } from "react-dom/client";
import "./index.scss";
import "react-toastify/dist/ReactToastify.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import Error from "shared/pages/error/Error";
import store from "./shared/store";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";
import "antd/dist/reset.css";

const USER_NOT_LOGGED_LD = {
  kind: "user",
  key: "user-key-123abc-nao-logado",
  name: "Usuário não logado",
  email: "usuarioNaoLogado@example.com",
};

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: process.env.REACT_APP_LAUNCH_DARKLY_CLIENT_ID!,
    timeout: 5,
    context: USER_NOT_LOGGED_LD,
  });
  const rootElement = document.getElementById("root");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <React.StrictMode>
        <Error>
          <Provider store={store}>
            <LDProvider>
              <App />
            </LDProvider>
          </Provider>
        </Error>
      </React.StrictMode>
    );
  }
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
